import {API} from "./API";
import {Position} from "../models/Position";

export class PositionsAPI extends API<Position> {

	constructor () {
		super("positions");
    }
}
